import ContentLoader from 'react-content-loader';
import styled from 'styled-components';
export const SwapDestinationDetailsContent = styled.div `
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  ${({ theme }) => theme.media.tablet `
  flex-direction: row;
`};
`;
export const DetailsWrapper = styled.div `
  background-color: ${({ theme }) => theme.colors.surface.interactiveDefault};
  padding: 2rem;
  margin-bottom: 1rem;
  border-radius: ${({ theme }) => theme.borderRadius.highM};
`;
export const DepositAddressWrapper = styled(ContentLoader) `
  height: 6rem;
  width: 100%;
  ${({ theme }) => theme.media.laptop `
      height: 4.5rem;
  `};
`;
export const DetailsLoaderWrapper = styled.div `
  width: 100%;
  display: flex;
  flex-direction: column;
`;
export const FloatRateWrapper = styled(ContentLoader) `
  height: 2rem;
  width: 100%;
`;
export const RecipientAddressWrapper = styled(ContentLoader) `
  height: 6rem;
  width: 100%;
  ${({ theme }) => theme.media.laptop `
      height: 4.5rem;
  `};
`;
export const DepositAddress = styled.rect `
  height: 6rem;
  width: 100%;

  rx: ${({ theme }) => theme.borderRadius.medium};
  ry: ${({ theme }) => theme.borderRadius.medium};

  ${({ theme }) => theme.media.laptop `
      height: 4.5rem;
  `};
`;
export const FloatRate = styled.rect `
  height: 2rem;
  width: 100%;

  rx: ${({ theme }) => theme.borderRadius.medium};
  ry: ${({ theme }) => theme.borderRadius.medium};

  ${({ theme }) => theme.media.laptop `
      height: 2rem;
  `};
`;
export const SwapQrLoaderContainer = styled.div `
  background-color: ${({ theme }) => theme.colors.surface.interactiveDefault};
  border-radius: ${({ theme }) => theme.borderRadius.highM};
  margin-bottom: 2rem;
  padding: 1.6rem;

  ${({ theme }) => theme.media.tablet `
     padding: 1.6rem;
     margin-bottom: 0;
     margin-right: 1.8rem;
  `};
`;
export const QrCodeContainer = styled(ContentLoader) `
  height: 11rem;
  width: 12rem;
  ${({ theme }) => theme.media.tablet `
     height: 25rem;
     width: 24rem;
  `};
`;
export const QrCode = styled.rect `
  height: 100%;
  width: 100%;
  rx: ${({ theme }) => theme.borderRadius.medium};
  ry: ${({ theme }) => theme.borderRadius.medium};
`;
export const RecipientAddress = styled.rect `
  height: 6rem;
  width: 100%;

  rx: ${({ theme }) => theme.borderRadius.medium};
  ry: ${({ theme }) => theme.borderRadius.medium};

  ${({ theme }) => theme.media.laptop `
      height: 4.5rem;
  `};
`;
//# sourceMappingURL=styles.js.map